import IsUsernameAvailableForShopRequestModelBase from '../_generated/modelBases/is-username-available-for-shop-request-model-base';

export default class IsUsernameAvailableForShopRequestModel extends IsUsernameAvailableForShopRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
